import SendingIcon from 'src/assets/icons/fi-rr-envelope.svg';
import { FieldMappingsMockUpType } from '../types';

export const selectedData = {
  value: '',
  to_crm_if_blank: true,
  from_sprouts: false,
  nosync: false,
  // crm to sproutes
  toSprouts: true,
  dontSyncToSprouts: false,
};

export const SendingFieldMappings: FieldMappingsMockUpType = {
  id: 'sending',
  label: 'Emails',
  testRunId: 'sendings',
  testRunLabel: 'Sendings',
  icon: SendingIcon,
  desc: 'Fields mapped',
  count: '0',
  entity: 'Mailings',
  sproutsFields: [
    {
      label: 'Owner ID',
      id: 'ownerId',
      selectedData,
      required: true,
      onlyOutbound:false,
    },
    {
      label: 'Contact ID',
      id: 'contactId',
      selectedData,
      required: true,
      onlyOutbound:false,
    },
    {
      label: 'Sequence ID',
      id: 'sequenceId',
      selectedData,
      onlyOutbound:false,
    },
    {
      label: 'CMP ID',
      id: 'cmpId',
      selectedData,
      required: true,
      onlyOutbound:false,
    },
    {
      label: 'Subject',
      id: 'subject',
      selectedData,
      onlyOutbound:false,
    },
    {
      label: 'Body',
      id: 'body',
      selectedData,
      onlyOutbound:false,
    },
    {
      label: 'Date UTC',
      id: 'dateUtc',
      selectedData,
      onlyOutbound:false,
    },
    {
      label: 'Message ID',
      id: 'messageId',
      selectedData,
      onlyOutbound:false,
    },
    {
      label: 'Bounced At',
      id: 'bouncedAt',
      selectedData,
      onlyOutbound:false,
    },
    {
      label: 'Click Count',
      id: 'clickCount',
      selectedData,
      onlyOutbound:false,
    },
    {
      label: 'Clicked At',
      id: 'clickedAt',
      selectedData,
      onlyOutbound:false,
    },
    {
      label: 'Delivered At',
      id: 'deleiverdAt',
      selectedData,
      onlyOutbound:false,
    },
    {
      label: 'Error Backtrace',
      id: 'errorBacktrace',
      selectedData,
      onlyOutbound:false,
    },
    {
      label: 'Error Reason',
      id: 'errorReason',
      selectedData,
      onlyOutbound:false,
    },
    {
      label: 'Mailbox Address',
      id: 'mailboxAddress',
      selectedData,
      onlyOutbound:false,
    },
    {
      label: 'Mailing Type',
      id: 'mailingType',
      selectedData,
      onlyOutbound:false,
    },
    {
      label: 'Marked As Spam At',
      id: 'markedAsSpamAt',
      selectedData,
      onlyOutbound:false,
    },
    {
      label: 'Open Count',
      id: 'openCount',
      selectedData,
      onlyOutbound:false,
    },
    {
      label: 'Opened At',
      id: 'openedAt',
      selectedData,
      onlyOutbound:false,
    },
    {
      label: 'Email References',
      id: 'emailReferences',
      selectedData,
      onlyOutbound:false,
    },
    {
      label: 'Replied At',
      id: 'repliedAt',
      selectedData,
      onlyOutbound:false,
    },
    {
      label: 'Retry At',
      id: 'retryAt',
      selectedData,
      onlyOutbound:false,
    },
    {
      label: 'Scheduled At',
      id: 'scheduledAt',
      selectedData,
      onlyOutbound:false,
    },
    {
      label: 'State',
      id: 'state',
      selectedData,
      onlyOutbound:false,
    },
    {
      label: 'Unsubscribed At',
      id: 'unsubscribedAt',
      selectedData,
      onlyOutbound:false,
    },
    {
      label: 'Updated At',
      id: 'updatedAt',
      selectedData,
      onlyOutbound:false,
    },
  ],
};